export const AVAILABLE_FONTS = [
  {
    id: 'noto-serif',
    name: 'Noto Serif JP',
    displayName: '明朝体',
    googleFont: 'Noto+Serif+JP:wght@400;500',
    fontFamily: '"Noto Serif JP", serif',
    description: '伝統的で上品な明朝体'
  },
  {
    id: 'noto-sans',
    name: 'Noto Sans JP',
    displayName: 'ゴシック体',
    googleFont: 'Noto+Sans+JP:wght@400;500',
    fontFamily: '"Noto Sans JP", sans-serif',
    description: '読みやすいモダンなゴシック体'
  },
  {
    id: 'klee',
    name: 'Klee One',
    displayName: '手書き風',
    googleFont: 'Klee+One:wght@400;600',
    fontFamily: '"Klee One", cursive',
    description: '温かみのある手書き風フォント'
  },
  {
    id: 'kaisei',
    name: 'Kaisei Tokumin',
    displayName: '楷書体',
    googleFont: 'Kaisei+Tokumin:wght@400;500',
    fontFamily: '"Kaisei Tokumin", serif',
    description: '正式で美しい楷書体風'
  },
  {
    id: 'mplus-rounded',
    name: 'M PLUS 1p',
    displayName: '丸ゴシック',
    googleFont: 'M+PLUS+1p:wght@400;500',
    fontFamily: '"M PLUS 1p", sans-serif',
    description: 'ポップで楽しい丸ゴシック'
  }
];

export const DEFAULT_FONT = AVAILABLE_FONTS[0]; // Noto Serif JP

export const getFontById = (fontId) => {
  return AVAILABLE_FONTS.find(font => font.id === fontId) || DEFAULT_FONT;
};